import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import HeadOfficeLeaseList from "containers/headoffice/HeadOfficeLeaseList";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Card, Col, Form, InputGroup, Modal, Nav, Row, Tab, Tabs } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import CreatableSelect from 'react-select/creatable';
import { PacmanLoader } from 'react-spinners';
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class HeadOfficeDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        

        this.state = {
            isLoading: null,
            isDeleting: null,
            modified: false,
            headOffice: null,
            showAlert: false,
            errorMessage: "",    
            leaseid: null,
            propertyid: null,
            headOfficeLeases: [],
            suburbOptions: [],
            selectedSuburb: null,
            

            led_head_office_id: null  ,
			tenant_name: null  ,
			address_line_1: null ,
			address_line_2: null ,
			suburb: null ,
			state: null ,
			postcode: null ,
			telephone: null ,
			fax: null ,
			weburl: null ,
			email: null ,
			notes: null ,            
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null

        };



       

    }

    

    componentWillUnmount() {
        this.setState({ headOffice: [] });
        source.cancel();
        
    }

  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   

            if (this.props.match.params.id === "new") {
                console.log("New head office");
                document.title = "New head office " ;
                this.syncroniseState();
                

            }
            else {
                await this.retrieveHeadOffice();
                if (this.props.location.state){
                    //If coming from a lease list do some prep work for the previous and next buttons
                    const leaseid = this.props.location.state.leaseid;
                    const propertyid = this.props.location.state.propertyid;
                    this.setState({leaseid,propertyid});
                }

                try {
                    await this.getHeadOfficeLeases({ledheadofficeid: this.state.led_head_office_id});
                }
                catch{
                    alert("Error loading leases");
                }

                
                document.title = "Head Office for " + this.state.tenant_name;
           
            }
            

            //Get lookups
            this.setState({ selectedSuburb: { value: this.state.suburb, label: this.state.suburb } });
            
            const suburbOptions = await this.getSuburbs();
            if (suburbOptions) {
                this.setState({ suburbOptions });
            }




            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    async syncroniseState() {
        const headOffice = {
            led_head_office_id: this.state.led_head_office_id  ,
            tenant_name: this.state.tenant_name,
            address_line_1: this.state.address_line_1 ,
            address_line_2: this.state.address_line_2 ,
            suburb: this.state.suburb ,
            state: this.state.state ,
            postcode: this.state.postcode ,
            telephone: this.state.telephone ,
            fax: this.state.fax ,
            weburl: this.state.weburl ,
            email: this.state.email ,
            notes: this.state.notes ,    
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by
        };

        this.setState({ headOffice });
    }

    async retrieveHeadOffice() {
        const headOffice = await this.getHeadOffice();
        
        if(headOffice){
        const { 
            led_head_office_id ,
            tenant_name,
            address_line_1 ,
            address_line_2 ,
            suburb ,
            state ,
            postcode ,
            telephone ,
            fax,
            weburl,
            email,
            notes ,    
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = headOffice;

        this.setState({
            headOffice,
            led_head_office_id ,
            tenant_name,
            address_line_1 ,
            address_line_2 ,
            suburb ,
            state ,
            postcode ,
            telephone ,
            fax,
            weburl,
            email,
            notes ,    
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });
    }

    }
    //Call API
    


    async getHeadOffice() {
        console.log("inside of getHeadOffice");
        return API.get("colin", `/headoffices/${this.props.match.params.id}`, { cancelToken: source.token });
    }

    async saveHeadOffice(headOffice, force=false) {
        console.log("Inside save entity");
        headOffice.force=force;
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.led_head_office_id === null) {
            this.setState({ created_by: this.props.user });
            return await API.post("colin", `/headoffices/new`, { body: headOffice });
        }
        return API.put("colin", `/headoffices/${this.state.led_head_office_id}`, {
            body: headOffice
        });
    }


    getHeadOfficeLeases(filter) {
        try {
            API.get("colin", `/headoffices/${this.props.match.params.id}/headofficeleases`, { 'queryStringParameters': filter }).then((headOfficeLeases) => {
                if (headOfficeLeases) {
                    this.setState(state => ({ headOfficeLeases }));
                }
            });
        }
        catch{
            console.log("Error getting head offices");
        }
    }

    getSuburbs() {
        return API.get("colin", `/suburbs`);
    }


    
    handleSuburbChange = (selectedSuburb) => {
        
        if (selectedSuburb) {
            this.setState({ selectedSuburb
                            ,suburb: selectedSuburb.suburb 
                            ,state: selectedSuburb.state 
                            ,postcode: selectedSuburb.postcode 
                            , modified: true },this.handleBlur);
        }
        else {
            this.setState({ selectedSuburb: { value: null, label: null }
                            ,suburb: null 
                            ,state: null
                            , postcode: null 
                            , modified: true },this.handleBlur);
        }
    }

    handleSuburbInputChange = event => {
                
        let suburbOptions = [...this.state.suburbOptions];
        suburbOptions.push({
            value: event, label: event
        });
        this.setState({ suburbOptions
                        ,selectedSuburb: { value: event, label: event } 
                        , suburb: event
                        , modified: true },this.handleBlur);
        
    }

  

    
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

    handlePercentChange = event => {
        let val = event.target.value.replace(/[^0-9.%]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleNumberChange = event => {
        let val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleMoneyChange = event => {
        let val = event.target.value.replace(/[^0-9.,$]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }



    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }        
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur);        
    }

   

    
    validateRelatedRecord(record, set) {
        //property
        if (set === "headOffice") {

            
            if (!this.state.tenant_name) {
                return [false, "You must enter a tenant name."];
            }

            if (this.state.email) {
                if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    return [false, "The email is not a correct format"];
                }
            }
    
            if(this.state.weburl){
                if(!this.state.weburl.match(/^[\w.-]{3}(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)){
                    return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
                }

            }

        }

        if (set === "headOfficeLeases") {

            // secondly check that UnitSort has been specified if required

            if (!record.tenant_name ) {
                return [false, "Enter a tenant name from a lease"];
            }

           


        }

        return [true,];
    }


    handleBlur = async event => {
        console.log("Inside handle blur");
        const field = event.target.id;
        if (this.state.modified === true) {
            this.setState({ showAlert: false });

                       
            await this.syncroniseState();
            
            
            const validation = this.validateRelatedRecord(this.state.headOffice, "headOffice");
            console.log(validation)
            if (validation[0] === true) {

                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving head office");
                    const result = await this.saveHeadOffice(this.state.headOffice);
                    this.setState({ isLoading: false });
                    if (result.result === false) {
                        if (result.id>=0){
                            alert(result.error_message);
                        }
                        else{
                            const confirmed = window.confirm(result.error_message + " Do you want to force a new head office creation?" );
                    
                            if (!confirmed) {
                                return;
                            }
                            else {
                                this.setState({ isLoading: true });
                                const result = await this.saveHeadOffice(this.state.headOffice, true);
                                this.setState({ isLoading: false });
                                if (result.result === false) {
                                    if(result.error_message!==""){
                                        alert(result.error_message);
                                    }
                                    else{
                                        alert("The force change did not work. Please reload the page and apply changes again.");
                                    }
                                }
                                else{
                                    if (this.props.match.params.id === "new") {
                                        this.setState(state => ({ led_head_office_id: result.id }));                            
                                        this.props.history.push("/headoffices/" + this.state.led_head_office_id);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ led_head_office_id: result.id }));                            
                            this.props.history.push("/headoffices/" + this.state.led_head_office_id);
                        }
                        else if (result.error_message!==""){
                            if(field==="tenant_name"){
                                alert(result.error_message);
                            }
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }

    


    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh ");
        if(dataset ==="headOfficeLeases"){
            try {
                await this.getHeadOfficeLeases({ledheadofficeid: this.state.led_head_office_id});
            }
            catch{
                alert("Error loading leases");
            }
        }
       
    }

    



    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
    }

    saveRecord(record, endpoint, id) {
        console.log("Inside save record");
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/headoffices/${this.state.led_head_office_id}/headofficeleases/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/headoffices/${this.state.led_head_office_id}/headofficeleases/${record[id]}`, {
            body: record
        }
        );
    }


    
    

  

    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {
            
            const confirmed = window.confirm(
                "Are you sure you want to delete this head office"
            );

            if (!confirmed) {
                return;
            }
            else {
                this.setState({ archived_date: new Date() }, () =>
                    this.syncroniseState().then(async () => {
                        const result = await this.saveHeadOffice(this.state.headOffice);
                        if (result.result === false) {
                            alert(result.error_message);
                        }
                        else {

                            this.props.history.push("/");
                        }
                    }
                    )
                );

            }

            
        }
    }


    render() {
        return (
            <div className="HeadOffice">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
               
                {this.state.headOffice && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="HeadOfficeForm">
                   
                    <Form  >
                        <Row>
                        <Col sm={4} md={4} lg={6}><h6>Head Office - {this.state.tenant_name} | {this.state.telephone} | {this.state.state} </h6></Col>
                      <Col>
                                <Nav className="justify-content-end " >
                                    {this.state.leaseid &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname: `/properties/${this.state.propertyid}/leases/${this.state.leaseid}` , state: {data: (this.props.location.state.data||[])}}}>
                                            <Button type="button" variant="primary" size="sm">Back to Lease {this.state.leaseid}</Button></LinkContainer>{" "}
                                    </Nav.Item>
                                    }
                                </Nav>
                        </Col>
                        </Row>
                    <Row  id="detail">
                        <Col>
                        <Modal show={this.state.showAlert && this.state.led_head_office_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                            <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                            <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                        </Modal>
                        {this.state.showAlert && !this.state.led_head_office_id &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                        <Tabs defaultActiveKey={0} id="tabset">
                        <Tab eventKey={0} title="Head Office Detail">
                            <Card >
     
                                        <Card.Body>                                            
                                        <Form.Row >
                                        <Col sm={12} md={6} lg={3}>

                                            <Card >

                                                <Card.Body>

                                                <Form.Group as={Row} controlId="led_head_office_id" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>ID</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                onBlur={this.handleBlur}
                                                                onChange={this.handleChange}
                                                                value={this.state.led_head_office_id}
                                                                as="input"
                                                                type="text"
                                                                disabled
                                                                
                                                            />
                                                        </Col>

                                                    </Form.Group>

                                                    <Form.Group as={Row} controlId="tenant_name" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Tenant Name</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                onBlur={this.handleBlur}
                                                                onChange={this.handleChange}
                                                                value={this.state.tenant_name}
                                                                as="input"
                                                                type="text"
                                                            />
                                                        </Col>

                                                    </Form.Group>
                                                    <Form.Group as={Row} controlId="telephone" >
                                                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Telephone</Form.Label>
                                                                    <Col>
                                                                        <Form.Control
                                                                        onChange={this.handleChange}
                                                                            value={this.state.telephone}
                                                                            as="input"
                                                                            type="text"
                                                                        onBlur={this.handleBlur}
                                                                        />
                                                                    </Col>

                                                                </Form.Group>
                                                                <Form.Group as={Row} controlId="fax" >
                                                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Fax</Form.Label>
                                                                    <Col>
                                                                        <Form.Control
                                                                        onChange={this.handleChange}
                                                                            value={this.state.fax}
                                                                            as="input"
                                                                            type="text"
                                                                        onBlur={this.handleBlur}
                                                                        />
                                                                    </Col>

                                                                </Form.Group>
                                                                <Form.Group as={Row} controlId="email" >
                                                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                                    <Col>
                                                                        <InputGroup>
                                                                            <InputGroup.Prepend><InputGroup.Text>@</InputGroup.Text></InputGroup.Prepend>
                                                                        <Form.Control
                                                                            onChange={this.handleChange}
                                                                            value={this.state.email}
                                                                            as="input"
                                                                            type="email"
                                                                            onBlur={this.handleBlur}

                                                                            />
                                                                            </InputGroup>
                                                                    </Col>
                                                                </Form.Group>

                                                                <Form.Group as={Row} controlId="weburl" >
                                                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Internet</Form.Label>
                                                                    <Col>
                                                                        <InputGroup>
                                                                            <InputGroup.Prepend><InputGroup.Text>www.</InputGroup.Text></InputGroup.Prepend>
                                                                        <Form.Control
                                                                            onChange={this.handleChange}
                                                                            value={this.state.weburl}
                                                                            as="input"
                                                                            type="text"
                                                                            onBlur={this.handleBlur}
                                                                            />
                                                                            </InputGroup>
                                                                    </Col>
                                                                </Form.Group>

                                                </Card.Body>
                                            </Card>



                                            </Col>

                                                <Col sm={12} md={6} lg={3}>

                                                    <Card >
                                                        
                                                        <Card.Body>
                                                    
                                                            <Form.Group as={Row} controlId="address_line_1" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 1</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.address_line_1}
                                                                        as="input"
                                                                        type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="address_line_2" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 2</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.address_line_2}
                                                                        as="input"
                                                                        type="text"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="suburb" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                                                <Col>
                                                                <CreatableSelect
                                                                            value={this.state.selectedSuburb}
                                                                            onChange={this.handleSuburbChange}
                                                                            options={this.state.suburbOptions}
                                                                        onCreateOption={this.handleSuburbInputChange}
                                                                        onBlur={this.handleBlur}
                                                                        isClearable
                                                                        />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="state" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onBlur={this.handleBlur}
                                                                        onChange={this.handleChange}
                                                                        value={this.state.state}
                                                                        as="input"
                                                                        type="text"
                                                                        
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="postcode" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onBlur={this.handleBlur}
                                                                        onChange={this.handleChange}
                                                                        value={this.state.postcode}
                                                                        as="input"
                                                                        type="text"
                                                                        
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                        
                                                        </Card.Body>
                                                        </Card>
                                                    </Col>

                                                

                                                <Col sm={12} md={6} lg={3}>

                                                    <Card >

                                                        <Card.Body>

                                                        <Form.Group as={Row} controlId="notes" >
                                                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Notes</Form.Label>
                                                                    <Col>
                                                                        <Form.Control
                                                                            onChange={this.handleChange}
                                                                            value={this.state.notes}
                                                                            as="textarea"
                                                                            rows="8"
                                                                        onBlur={this.handleBlur}
                                                                        />
                                                                    </Col>

                                                                </Form.Group>

                                                        </Card.Body>
                                                    </Card>



                                                </Col>


                                            
                                                
                                            


                                        </Form.Row>






                                    </Card.Body>
                                
                            </Card >
                        </Tab>
                    
                        
                        <Tab eventKey={1} title="Leases">

                        <Card >
                            <Card.Body>
                            <HeadOfficeLeaseList
                                    isAuthenticated={this.props.isAuthenticated}
                                    user={this.props.user}
                                    data={this.state.headOfficeLeases}
                                    updateTableState={this.updateTableState}
                                    saveRecord={this.saveRecord}
                                    deleteRecord={this.deleteRecord}
                                    refreshDataSet={this.refreshDataSet}
                                    validateRelatedRecord={this.validateRelatedRecord}
                                    ledheadofficeid={this.state.led_head_office_id}
                                    
                                />
                            </Card.Body>
                        </Card>

                        </Tab>

                                <Tab eventKey={2} title="Record History">
                                            <Card style={{ width: '28rem' }}>
                                        <Card.Body>
                                                    <Form.Group as={Row} controlId="created_date" >
                                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                    .local()
                                                                    .format("DD-MM-YYYY"): ""}
                                                                plaintext readOnly
                                                            />
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} controlId="created_by" >
                                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                value={this.state.created_by}
                                                                plaintext readOnly
                                                            />
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} controlId="last_edited_date" >
                                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                    .local()
                                                                    .format("DD-MM-YYYY"): ""}
                                                                plaintext readOnly
                                                            />
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} controlId="last_edited_by" >
                                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                value={this.state.last_edited_by}
                                                                plaintext readOnly
                                                            />
                                                        </Col>
                                                    </Form.Group>

                                        </Card.Body>
                                    </Card>

                                </Tab>

                            
                        </Tabs>

                        </Col>

                    </Row>
                   

                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}